import React from 'react';
import { useTranslation } from 'react-i18next';

export default function BreadcrumbTrail({ isSearch }) {
  const { t, i18n } = useTranslation('translation');

  return (
    <nav id="wb-bc" property="breadcrumb" aria-labelledby="breadcrumbPosition">
      <h2 id="breadcrumbPosition">{t("You are here:")}</h2>
      <div className="container">
        {/* <ol 
          className="breadcrumb" 
          style={{
            paddingLeft: 0,
            marginLeft: 0,
            listStyle: 'none',
          }}
        >
          <li>
            <a href={`https://www.canada.ca/${i18n.language}.html`}>{t("Canada.ca")}</a>
          </li>
          <li>
            <a
              href={
                i18n.language === "fr"
                  ? "https://ressources-naturelles.canada.ca/"
                  : "https://natural-resources.canada.ca/"
              }
            >
              {t("Natural Resources Canada")}
            </a>
          </li>
          <li>
            <a href={`/${i18n.language}/nrcan-map`}>{t("Mine Permit Navigator")}</a>
          </li>
          {isSearch ? (
            <li>
              <a href={`/${i18n.language}/search`}>{t("Guided Search")}</a>
            </li>
          ) : null}
        </ol> */}
        <ol 
        class="breadcrumb"
        style={{
            paddingLeft: 0,
            marginLeft: 0,
            listStyle: 'none',
          }}>
                  <li>
                          <a href={`https://www.canada.ca/${i18n.language}.html`}>{t("Canada.ca")}</a>
                      </li>
                  <li>
                          <a
                      href={
                        i18n.language === "fr"
                          ? "https://ressources-naturelles.canada.ca/"
                          : "https://natural-resources.canada.ca/"
                      }
                    >
                      {t("Natural Resources Canada")}
                    </a>
                      </li>
                  <li>
                          <a href="https://natural-resources.canada.ca/minerals-mining">{t("Minerals and mining")}</a>
                      </li>
                  <li>
                          <a href="https://natural-resources.canada.ca/minerals-mining/services-mining-industry">{t("Services for the mining industry")}</a>
                      </li>
                      <li>
                    <a href={`/${i18n.language}/nrcan-map`}>{t("Mine Permit Navigator")}</a>
                  </li>
              </ol>
      </div>
    </nav>
  );
}